import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard-2" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexProject',
  setup(__props) {

const ProjectStatus = defineAsyncComponent(() => import("@/components/theme/dashboards/project/ProjectStatus.vue"))
const TotalProject = defineAsyncComponent(() => import("@/components/theme/dashboards/project/TotalProject.vue"))
const ProjectsOverview = defineAsyncComponent(() => import("@/components/theme/dashboards/project/ProjectsOverview.vue"))
const ProjectCard = defineAsyncComponent(() => import("@/components/theme/dashboards/project/ProjectCard.vue"))
const TodaysTasks = defineAsyncComponent(() => import("@/components/theme/dashboards/project/TodaysTasks.vue"))
const RunningEvents = defineAsyncComponent(() => import("@/components/theme/dashboards/project/RunningEvents.vue"))
const RecentProjects = defineAsyncComponent(() => import("@/components/theme/dashboards/project/RecentProjects.vue"))
const ClientsActivit = defineAsyncComponent(() => import("@/components/theme/dashboards/project/ClientsActivit.vue"))
const OnlineTimeline = defineAsyncComponent(() => import("@/components/theme/dashboards/project/OnlineTimeline.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ProjectStatus)),
      _createVNode(_unref(RecentProjects)),
      _createVNode(_unref(TotalProject)),
      _createVNode(_unref(ProjectsOverview)),
      _createVNode(_unref(ClientsActivit)),
      _createVNode(_unref(ProjectCard)),
      _createVNode(_unref(TodaysTasks)),
      _createVNode(_unref(RunningEvents)),
      _createVNode(_unref(OnlineTimeline))
    ])
  ]))
}
}

})